import React from 'react';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import { ICONS } from 'Components/utils/icon/icons';
import type { AdditionItemProps } from 'Components/frameworks/addition/Addition';
import { Addition } from 'Components/frameworks/addition/Addition';
import { Icon } from 'Components/frameworks/icon/Icon';
import { TextLink } from 'Components/frameworks/text-link/TextLink';
type Props = {
  items: Array<AdditionItemProps>;
};
export const AllInclusivePush = ({ items = [] }: Props) => {
  const { isTablet } = useResponsive();

  if (!items.length) {
    return null;
  }

  const filteredItems = items.filter((item) => item.label || item.icon);
  const {
    icon: lastIcon = {},
    label: lastLabel = '',
    link: lastLink = {},
  } = filteredItems.pop() || {};
  return isTablet ? (
    <Addition items={items} />
  ) : (
    <ul className="space-y-10">
      {filteredItems.map(({ label }) => (
        <li className="flex items-center gap-10 text-14 font-bold text-black" key={label}>
          <Icon className="text-sienna" name={ICONS.CHECK} width="1em" />
          {label}
        </li>
      ))}
      <li className="flex flex-col gap-10">
        <Icon
          className="text-black"
          isNotSquare
          name={(lastIcon as { name?: string }).name}
          width="40%"
        />
        {(lastIcon as { alt?: string }).alt && (
          <span className="sr-only">{(lastIcon as { alt?: string }).alt} </span>
        )}
        <TextLink className="self-end underline" label={lastLabel} url={lastLink.url} />
      </li>
    </ul>
  );
};
